var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"generate-ppt"},[_c('h1',[_vm._v("生成PPT")]),_c('p',[_vm._v("这里是生成PPT的内容。")])])}]

export { render, staticRenderFns }